<template>

    <m-edit1/>

    <m-single-product-500-reservation v-bind='{...{"productLink":null,"relatedProducts":true,"productCardName":"mProductCard310_Category","relatedCourse":false,"galleryFullSlider":false,"showWhatsAppButtonsMessage":null,"showLastUpdate":false,"title":"","productCategories":null,"productBrands":null,"waitForCategory":false,"waitForBrand":false,"categoryColumn":"slug","brandColumn":"slug","productCardLink":false,"productCardLinkTarget":"_self","activeLatestFilter":true,"activeCategoryFilter":true,"showKeywords":false,"showDefaultSlideItem":false,"swiperPerViewSM":2,"swiperPerViewMD":2,"swiperPerViewLG":3,"autoPlay":false,"autoPlayDuration":1000},...{}}' :style='""' class="container my-5" ></m-single-product-500-reservation>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleProduct500Reservation from '@moeinmdn/miw-alpha-components/src/package/Product/Single/SingleProduct500Reservation';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleProduct500Reservation },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
